import React, { createContext, useContext, ReactNode } from 'react'
import { useI18n, I18nContextType } from './useI18n'

// 创建上下文
const I18nContext = createContext<I18nContextType | undefined>(undefined)

// 多语言提供者组件
interface I18nProviderProps {
  children: ReactNode
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const i18n = useI18n()

  return (
    <I18nContext.Provider value={i18n}>
      {children}
    </I18nContext.Provider>
  )
}

// 使用多语言上下文的 Hook
export const useI18nContext = (): I18nContextType => {
  const context = useContext(I18nContext)
  if (context === undefined) {
    throw new Error('useI18nContext must be used within an I18nProvider')
  }
  return context
}

// 导出类型
export type { I18nContextType }
